import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';

import AddAddressButton from './AddAddressButton';
import Address from './Address';

const AddressButtonContainer = ({ ...props }) => {
  const regions = useSelector((state) => state.regionsReducer.regions);

  const { addresses, onClick, onClickEdit } = props;

  const handleClick = (event) => {
    onClick(event);
  };

  const handleClickEditAddress = (address) => {
    onClickEdit(address);
  };

  return (
    <React.Fragment>
      {addresses.length === 0 && (
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <AddAddressButton onClick={handleClick} />
          </Grid>
          <Grid item md={6} xs={12}>
            <AddAddressButton disabled />
          </Grid>
        </Grid>
      )}
      {addresses.length % 2 === 1 && (
        <Grid container spacing={3}>
          {addresses.map((address, key) => (
            <Grid item md={6} xs={12} key={key}>
              <Address
                address={address}
                regions={regions}
                onClickEdit={handleClickEditAddress}
              />
            </Grid>
          ))}
          <Grid item md={6} xs={12}>
            <AddAddressButton onClick={handleClick} />
          </Grid>
        </Grid>
      )}
      {addresses.length % 2 === 0 && addresses.length !== 0 && (
        <Grid container spacing={3}>
          {addresses.map((address, key) => (
            <Grid item md={6} xs={12} key={key}>
              <Address
                address={address}
                regions={regions}
                onClickEdit={handleClickEditAddress}
              />
            </Grid>
          ))}
          <Grid item md={6} xs={12}>
            <AddAddressButton onClick={handleClick} />
          </Grid>
          <Grid item md={6} xs={12}>
            <AddAddressButton disabled />
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
};

AddressButtonContainer.propTypes = {
  addresses: PropTypes.array,
  onClick: PropTypes.func,
  onClickEdit: PropTypes.func,
};

export default AddressButtonContainer;
